var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/contentful-module-spacing.j2"] = require( "macros/contentful-module-spacing.j2" );
dependencies["macros/contentful/render-entry.j2"] = require( "macros/contentful/render-entry.j2" );
dependencies["./carousel-module-arrow.j2"] = require( "./carousel-module-arrow.j2" );
dependencies["./carousel-module-pause.j2"] = require( "./carousel-module-pause.j2" );
dependencies["./carousel-module-play.j2"] = require( "./carousel-module-play.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/carousel-module.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/contentful-module-spacing.j2", false, "core/templates/contentful/carousel-module.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("calculateModuleSpacing")) {
var t_4 = t_1.calculateModuleSpacing;
} else {
cb(new Error("cannot import 'calculateModuleSpacing'")); return;
}
context.setVariable("calculateModuleSpacing", t_4);
env.getTemplate("macros/contentful/render-entry.j2", false, "core/templates/contentful/carousel-module.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("renderEntry")) {
var t_8 = t_5.renderEntry;
} else {
cb(new Error("cannot import 'renderEntry'")); return;
}
context.setVariable("renderEntry", t_8);
var t_9;
t_9 = env.getFilter("trim").call(context, (lineno = 3, colno = 47, runtime.callWrap(t_4, "calculateModuleSpacing", context, [runtime.contextOrFrameLookup(context, frame, "entry"),1,1])));
frame.set("entrySpacingClass", t_9, true);
if(frame.topLevel) {
context.setVariable("entrySpacingClass", t_9);
}
if(frame.topLevel) {
context.addExport("entrySpacingClass", t_9);
}
output += "\n\n";
var t_10;
t_10 = "s-carousel-arrows--" + env.getFilter("lower").call(context, (lineno = 5, colno = 46, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["entry.fields.colorScheme","light"])));
frame.set("arrowClass", t_10, true);
if(frame.topLevel) {
context.setVariable("arrowClass", t_10);
}
if(frame.topLevel) {
context.addExport("arrowClass", t_10);
}
output += "\n\n<div class=\"s-contentful-carousel ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "arrowClass"), env.opts.autoescape);
output += "\n o-carousel__wrapper ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "entrySpacingClass"), env.opts.autoescape);
output += " js-contentful-carousel\" data-qa-carousel-module=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "moduleIndex"), env.opts.autoescape);
output += "\">\n    ";
if(!runtime.contextOrFrameLookup(context, frame, "carouselClass")) {
output += "\n        ";
var t_11;
t_11 = "js-carousel";
frame.set("carouselClass", t_11, true);
if(frame.topLevel) {
context.setVariable("carouselClass", t_11);
}
if(frame.topLevel) {
context.addExport("carouselClass", t_11);
}
output += "\n    ";
;
}
output += "\n\n    ";
var t_12;
t_12 = (runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"autoPlayTiming")?runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"autoPlayTiming"):"0");
frame.set("autoPlayTiming", t_12, true);
if(frame.topLevel) {
context.setVariable("autoPlayTiming", t_12);
}
if(frame.topLevel) {
context.addExport("autoPlayTiming", t_12);
}
output += "\n    ";
var t_13;
t_13 = (lineno = 14, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["entry.fields.loopCarousel",runtime.contextOrFrameLookup(context, frame, "False")]));
frame.set("isLoop", t_13, true);
if(frame.topLevel) {
context.setVariable("isLoop", t_13);
}
if(frame.topLevel) {
context.addExport("isLoop", t_13);
}
output += "\n\n    <div class=\"o-carousel o-carousel__arrows-";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"carouselControlPlacement"), env.opts.autoescape);
output += " u-centered-content ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "carouselClass"), env.opts.autoescape);
output += "\" data-auto-play-timing=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "autoPlayTiming"), env.opts.autoescape);
output += " data-is-loop=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "isLoop"), env.opts.autoescape);
output += ">\n        <div class=\"o-carousel__inner ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "carouselClass"), env.opts.autoescape);
output += "__inner\">\n\n        ";
frame = frame.push();
var t_16 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"components");
if(t_16) {var t_15 = t_16.length;
for(var t_14=0; t_14 < t_16.length; t_14++) {
var t_17 = t_16[t_14];
frame.set("component", t_17);
frame.set("loop.index", t_14 + 1);
frame.set("loop.index0", t_14);
frame.set("loop.revindex", t_15 - t_14);
frame.set("loop.revindex0", t_15 - t_14 - 1);
frame.set("loop.first", t_14 === 0);
frame.set("loop.last", t_14 === t_15 - 1);
frame.set("loop.length", t_15);
output += "\n            <div class=\"o-carousel__slide ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "carouselClass"), env.opts.autoescape);
output += "__slide js-carousel-zoom__slide ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") > 0) {
output += "o-carousel--hidden";
;
}
output += "\">\n                ";
var t_18;
t_18 = t_17;
frame.set("entryComponent", t_18, true);
if(frame.topLevel) {
context.setVariable("entryComponent", t_18);
}
if(frame.topLevel) {
context.addExport("entryComponent", t_18);
}
output += "\n                ";
output += runtime.suppressValue((lineno = 22, colno = 28, runtime.callWrap(t_8, "renderEntry", context, [runtime.contextOrFrameLookup(context, frame, "entryComponent"),runtime.makeKeywordArgs({"entryloop": runtime.contextOrFrameLookup(context, frame, "entryloop"),"isLazy": runtime.contextOrFrameLookup(context, frame, "isLazy")})])), env.opts.autoescape);
output += "\n            </div>\n        ";
;
}
}
frame = frame.pop();
output += "\n        </div>\n    </div>\n\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"showArrows")) {
output += "\n\n        <button class=\"o-carousel__button o-carousel__button--prev ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "carouselClass"), env.opts.autoescape);
output += "__button--prev o-carousel__button--";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"carouselControlPlacement"), env.opts.autoescape);
output += "-prev js-carousel-zoom__button--prev o-carousel--hidden\"\n            aria-label=\"Previous slide\"\n            data-qa-carousel-prev-arrow>\n\n            ";
env.getTemplate("./carousel-module-arrow.j2", false, "core/templates/contentful/carousel-module.j2", null, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
t_19.render(context.getVariables(), frame, function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
output += t_20
output += "\n\n        </button>\n\n        <button class=\"o-carousel__button o-carousel__button--next ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "carouselClass"), env.opts.autoescape);
output += "__button--next o-carousel__button--";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"carouselControlPlacement"), env.opts.autoescape);
output += "-next o-carousel--hidden js-carousel-zoom__button--next\"\n            aria-label=\"Next slide\"\n            data-qa-carousel-next-arrow>\n\n            ";
env.getTemplate("./carousel-module-arrow.j2", false, "core/templates/contentful/carousel-module.j2", null, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
t_23.render(context.getVariables(), frame, function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
output += t_24
output += "\n\n        </button>\n\n    ";
})})})});
}
output += "\n\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"showPagination")) {
output += "\n\n        <div class=\"o-carousel__pagination ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "carouselClass"), env.opts.autoescape);
output += "__pagination js-carousel-zoom__pagination\" data-qa-carousel-pagination></div>\n\n    ";
;
}
output += "\n\n    ";
if(env.getFilter("int").call(context, runtime.contextOrFrameLookup(context, frame, "autoPlayTiming")) > 0 && env.getFilter("lower").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"carouselControls")) != "none") {
output += "\n\n        <div class=\"o-carousel__play-pause js-carousel__pause\" data-qa-carousel-play-pause tabindex=\"0\">\n\n            ";
env.getTemplate("./carousel-module-pause.j2", false, "core/templates/contentful/carousel-module.j2", null, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
t_27.render(context.getVariables(), frame, function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
output += t_28
output += "\n\n        </div>\n\n        <div class=\"o-carousel__play-pause js-carousel__play\" data-qa-carousel-play-pause tabindex=\"0\" hidden>\n\n            ";
env.getTemplate("./carousel-module-play.j2", false, "core/templates/contentful/carousel-module.j2", null, function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
t_31.render(context.getVariables(), frame, function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
output += t_32
output += "\n\n        </div>\n    ";
})})})});
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/carousel-module.j2"] , dependencies)